var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClientsvg2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 406,
    height: 400,
    viewBox: "0 0 406 400",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M574.392 287.808C574.392 446.422 445.81 575.004 287.196 575.004C128.582 575.004 0 446.422 0 287.808C0 129.194 128.582 0.611816 287.196 0.611816C445.81 0.611816 574.392 129.194 574.392 287.808ZM90.404 287.808C90.404 396.493 178.511 484.6 287.196 484.6C395.881 484.6 483.988 396.493 483.988 287.808C483.988 179.123 395.881 91.0158 287.196 91.0158C178.511 91.0158 90.404 179.123 90.404 287.808Z",
    fill: "#FFE4E4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClientsvg2);
export default __webpack_public_path__ + "static/media/clientsvg2.d1a978a27ffdd30e6c89d632ecb875de.svg";
export { ForwardRef as ReactComponent };